import { Fragment, useState } from "react";
import CustomPopup from "../Popups/CustomPopup.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import Tooltip from "../../../Elements/Tooltip/Tooltip.js";
import { getActionsBasedOnMailType } from "./../helpers.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import useInboxActionsList from "./useInboxActionsList.js";
import ReuploadActionComponent from "../Mails/ReuploadActionComponent.tsx";
import { DownloadpageActionComponent } from "../Mails/DownloadpageActionComponent.js";
import useInboxQueryParams from "hooks/useInboxQueryParams.ts";

const ActionComponent = ({
  iconName,
  clickAction,
  name,
  iconSrc,
  style = {},
}) => {
  const { getTextByKey } = useContent();

  return (
    <div className="action-container" onClick={clickAction} style={style}>
      <Tooltip tooltipText={getTextByKey(`tooltip-action-${name}-text-1`)}>
        <Icon name={iconName} src={iconSrc} gray />
      </Tooltip>
    </div>
  );
};

export const ActionExpandedComponent = ({
  iconName,
  clickAction,
  name,
  textKey,
}) => {
  const { getTextByKey } = useContent();

  return (
    <li className="mail-split-tab-bar-item" onClick={clickAction}>
      <div
        className={`mail-split-tab-bar-item-icon ${
          name === "convert-to-picker" ? "picker-icon" : "action-icon"
        }`}
      >
        <Icon name={iconName} gray large />
      </div>
      <div className="mail-split-tab-bar-item-text">
        {getTextByKey(textKey || "tooltip-action-" + name + "-text")}
      </div>
    </li>
  );
};

const MailActionsComponent = ({
  mailData,
  listItemRef,
  all,
  asIcons,
  isFirstElementForProductTour,
}) => {
  const { getQueryParam } = useInboxQueryParams();
  const { getDirection } = useContent();
  const [showActions, setShowActions] = useState(false);
  const actionsList = useInboxActionsList({ mailData, listItemRef });
  const actions = getActionsBasedOnMailType(
    all,
    mailData,
    actionsList
  );
  const [showActionList, setShowActionList] = useState(false);

  const toggleShowActionList = () => {
    setShowActionList((prev) => !prev);
  };

  if (!actions?.filter((action) => !!action)?.length) return null;

  return asIcons ? (
    <div
      className="actions-component-wrapper"
      id={isFirstElementForProductTour ? "actions-component-wrapper" : ""}
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="actions-menu-icon-wrapper">
        <Icon name="more" alt="actions" large gray />
        <CustomPopup showState={showActions}>
          <div
            className={`action-component action-component-${getDirection()}`}
          >
            {actions?.map((item, i) => {
              return item ? (
                <ActionComponent
                  {...item}
                  key={item.name}
                  mailId={mailData.id}
                  style={{
                    animationDelay: `${(actionsList?.length - i) / 15}s`,
                  }}
                />
              ) : null;
            })}
            {mailData.mailStatus !== "removed" ? (
              <ActionComponent
                iconName="remove"
                clickAction={null}
                name="remove-mail-completely-disabled"
                style={{
                  opacity: 0.6,
                }}
              />
            ) : null}
          </div>
        </CustomPopup>
      </div>
    </div>
  ) : (
    <div
      onMouseEnter={toggleShowActionList}
      onMouseLeave={toggleShowActionList}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={`dots-vertical-icon ${showActionList ? "selected" : ""}`}>
        <Icon name="dots-vertical" xl gray />
      </div>
      <CustomPopup showState={showActionList} topPosition={40}>
        <ul
          className="mail-split-action-list"
          id={isFirstElementForProductTour ? "mail-split-action-list" : ""}
        >
          {getQueryParam("t") !== "trash" ? (
            <ReuploadActionComponent
              mailData={mailData}
              isFromSplitPanel={true}
            />
          ) : null}
          {actions?.map((item, i) => {
            return item ? (
              <Fragment key={item.name}>
                <ActionExpandedComponent {...item} />
                {i === 1 && (
                  <>
                    {mailData.mailStatus !== "removed" &&
                    getQueryParam("t") !== "trash" ? (
                      <DownloadpageActionComponent
                        data={mailData}
                        isJmForm={mailData?.isJForm}
                        isFromSplitPanel={true}
                        hideAdditioanlIcons={true}
                      />
                    ) : null}
                    {actions?.length > 3 && <hr />}
                  </>
                )}
                {i === 6 && <hr />}
              </Fragment>
            ) : null;
          })}
        </ul>
      </CustomPopup>
    </div>
  );
};

export default MailActionsComponent;
